export default __webpack_public_path__ + "static/media/approve.42d015ad.svg";